import { useEffect, useState } from "react";
import api from "@/lib/api";

export const MED_TYPES = [
  { key: "tablet", label: "Tablet", unit: "strip", unit_label: "Strip", loose_label: "Tab" },
  { key: "capsule", label: "Capsule", unit: "strip", unit_label: "Strip", loose_label: "Cap" },
  { key: "softgel", label: "Softgel", unit: "strip", unit_label: "Strip", loose_label: "Cap" },
  { key: "syrup", label: "Syrup", unit: "bottle", unit_label: "Bottle" },
  { key: "suspension", label: "Suspension", unit: "bottle", unit_label: "Bottle" },
  { key: "drops", label: "Drops", unit: "bottle", unit_label: "Bottle" },
  { key: "dry-syrup", label: "Dry Syrup", unit: "bottle", unit_label: "Bottle" },
  { key: "powder", label: "Powder", unit: "pack", unit_label: "Pack" },
  { key: "sachet", label: "Sachet", unit: "pack", unit_label: "Pack" },
  { key: "injection", label: "Injection", unit: "vial", unit_label: "Vial" },
  { key: "infusion", label: "Infusion (IV)", unit: "bottle", unit_label: "Bottle" },
  { key: "cream", label: "Cream", unit: "tube", unit_label: "Tube" },
  { key: "ointment", label: "Ointment", unit: "tube", unit_label: "Tube" },
  { key: "gel", label: "Gel", unit: "tube", unit_label: "Tube" },
  { key: "lotion", label: "Lotion", unit: "bottle", unit_label: "Bottle" },
  { key: "spray", label: "Spray", unit: "piece", unit_label: "Piece" },
  { key: "inhaler", label: "Inhaler", unit: "piece", unit_label: "Piece" },
  { key: "respule", label: "Respule", unit: "piece", unit_label: "Piece" },
  { key: "eye-drop", label: "Eye Drop", unit: "bottle", unit_label: "Bottle" },
  { key: "ear-drop", label: "Ear Drop", unit: "bottle", unit_label: "Bottle" },
  { key: "nasal-drop", label: "Nasal Drop", unit: "bottle", unit_label: "Bottle" },
  { key: "suppository", label: "Suppository", unit: "pack", unit_label: "Pack" },
  { key: "pessary", label: "Pessary", unit: "pack", unit_label: "Pack" },
  { key: "mouthwash", label: "Mouthwash", unit: "bottle", unit_label: "Bottle" },
  { key: "shampoo", label: "Shampoo", unit: "bottle", unit_label: "Bottle" },
  { key: "soap", label: "Soap", unit: "piece", unit_label: "Piece" },
  { key: "patch", label: "Patch", unit: "pack", unit_label: "Pack" },
  { key: "other", label: "Other", unit: "piece", unit_label: "Piece" },
];

// DB values (rename/custom types) static defaults ko override karte hain
let ALL = [...MED_TYPES];

export function useMedTypes(version = 0) {
  const [types, setTypes] = useState(ALL);
  useEffect(() => {
    api.get("/med-types").then(({ data }) => {
      const db = data || [];
      const dbMap = new Map(db.map((d) => [d.key, d]));
      ALL = [
        ...MED_TYPES.map((m) => (dbMap.has(m.key) ? { ...m, ...dbMap.get(m.key) } : m)),
        ...db.filter((d) => !MED_TYPES.some((m) => m.key === d.key)),
      ];
      setTypes(ALL);
    }).catch(() => {});
  }, [version]);
  return types;
}

const find = (t) => ALL.find((x) => x.key === (t || "tablet")) || MED_TYPES[0];
export const isStripType = (t) => find(t).unit === "strip";
export const medTypeOf = (m) => m?.med_type || "tablet";
export const medTypeLabelOf = (m) => find(medTypeOf(m)).label;
export const unitLabelOf = (m) => find(medTypeOf(m)).unit_label;
export const looseLabelOf = (m) => find(medTypeOf(m)).loose_label || "Piece";
export const unitKeyOf = (m) => find(medTypeOf(m)).unit;
